import type { FC } from "react";
import AddDMSContent from "@/components/MediaSelector/forms/AddDMSContent";
import MediaType from "@/declarations/models/MediaType";
import type { AddMediaContentProps } from "@/components/MediaSelector/AddMediaModal";

export const AddVideoMedia: FC<AddMediaContentProps> = ({ value, onCancel, onMediaSaved, ownerId, instanceId }) => (
  <AddDMSContent
    allowedMediaTypes={[MediaType.VIDEO]}
    media={value ?? null}
    onMediaSaved={onMediaSaved}
    onCancel={onCancel}
    ownerId={ownerId}
    instanceId={instanceId}
  />
);

export default AddVideoMedia;
